<template>
  <page-header></page-header>

  <div class="innerbanner support_banner">
    <div class="container-sm">
      <div class="row">
        <div class="col-lg-6">
          <div class="innerBannerText content-middle">
            <h1>SOUTIEN</h1>
            <div>
              Votre entreprise est importante pour nous. Si vous avez besoin de
              plus d'informations ou de soutien, nous sommes là pour vous !
              Prenez contact avec nous dès aujourd'hui !
            </div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="inBannerImg">
            <img src="../../assets/supportBanner-1.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="customerSupport">
    <div class="container-sm">
      <h3 class="secondHead text-center">COMMENT POUVONS-NOUS VOUS AIDER ?</h3>
      <p class="text-center">
        Faites-nous savoir de quel type de soutien vous avez besoin en
        sélectionnant l'une des options ci-dessous.
      </p>

      <form   class="supportForm"    method="post"     action=""   >
        <div class="radio-option my-5">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              id="radio2"
              @click="shipWithUsForm()"
              name="optradio"
              value="patner"
            />
            <label class="form-check-label" for="radio2">Expédier avec nous</label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              id="radio1"
              @click="customerServiceForm()"
              name="optradio"
              value="shipmentTracking"
            />
            <label class="form-check-label" for="radio1"
              >Service à la clientèle</label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              id="radio3"
              name="optradio"
              @click="driveForUsRedirect()"
              value="courier"
              class="form-check-input"
            />
            <label class="form-check-label" for="radio3">Conduire pour nous</label>
          </div>
        </div>
      </form>
      <div id="shipWithUs" class="hide">
        <form class="supportForm" action="">
          <h5 class="my-5 personal-head text-black">
            <span>PERSONAL DETAILS</span>
          </h5>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >First Name<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="firstName"
                    v-model="first_name_ship"
                    required=""
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Last Name<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="lastName"
                    v-model="last_name_ship"
                    required=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Email address<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="email"
                    class="form-control"
                    name="lemail"
                    v-model="email_address_ship"
                    required=""
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Phone number<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="phoneNumber1"
                    required=""
                    placeholder="XXX XXX XXXX"
                    v-model="phone_ship"
                    pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                    maxlength="12"
                  />
                </div>
              </div>
            </div>
          </div>

          <h5 class="my-5"><span>ORGANIZATION DETAILS</span></h5>

          <div class="mb-3 row">
            <div class="col-md-12">
              <div class="mb-4 row">
                <label class="col-sm-2 col-form-label"
                  >Name of organization<span class="text-danger">*</span></label
                >
                <div class="col-sm-10">
                  <input
                    type="text"
                    class="form-control"
                    name="organization"
                    v-model="org_ship"
                    required=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >City<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="city"
                    v-model="city_ship"
                    required=""
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Province<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="province1"
                    v-model="province_ship"
                    required=""
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-5 col-form-label"
                  >Estimated shipping volumes<span class="text-danger"
                    >*</span
                  ></label
                >
                <div class="col-sm-7">
                  <input
                    type="text"
                    class="form-control"
                    name="estimatedVol"
                    v-model="shipping_vol_ship"
                    required=""
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6 domestic_radio">
              <div class="mb-3 row">
                <label class="col-sm-4 col-4 col-form-label"
                  >Domestic<span class="text-danger">*</span></label
                >
                <div class="col-sm-8 col-8">
                  <div class="row g-0">
                    <div class="col-4">
                      <div class="form-check">
                        <input
                          class="form-check-input domestic_yes"
                          value="yes"
                          type="radio"
                          name="domestic"
                          id="flexRadioDefault1"
                          checked=""
                        />
                        <label class="form-check-label" for="flexRadioDefault1">
                          Yes
                        </label>
                      </div>
                    </div>

                    <div class="col-4">
                      <div class="form-check">
                        <input
                          class="form-check-input domestic_no"
                          value="no"
                          type="radio"
                          name="domestic"
                          id="flexRadioDefault2"
                        />
                        <label class="form-check-label" for="flexRadioDefault2">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6 domestic_radio">
              <div class="mb-3 row">
                <label class="col-sm-5 col-4 col-form-label"
                  >Under 50 lbs<span class="text-danger">*</span></label
                >
                <div class="col-sm-7 col-8">
                  <div class="row g-0">
                    <div class="col-4">
                      <div class="form-check">
                        <input
                          class="form-check-input under_yes"
                          value="yes"
                          type="radio"
                          name="under50"
                          id="flexRadioDefault3"
                          checked=""
                        />
                        <label class="form-check-label" for="flexRadioDefault3">
                          Yes
                        </label>
                      </div>
                    </div>

                    <div class="col-4">
                      <div class="form-check">
                        <input
                          class="form-check-input under_no"
                          value="no"
                          type="radio"
                          name="under50"
                          id="flexRadioDefault4"
                        />
                        <label class="form-check-label" for="flexRadioDefault4">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 domestic_radio">
              <div class="mb-3 row">
                <label class="col-sm-4 col-4 col-form-label pe-lg-4 pe-0"
                  >Dangerous Goods<span class="text-danger">*</span></label
                >
                <div class="col-sm-8 col-8">
                  <div class="row g-0">
                    <div class="col-4">
                      <div class="form-check">
                        <input
                          class="form-check-input dangerous_yes"
                          value="yes"
                          type="radio"
                          name="noDangerous"
                          id="flexRadioDefault5"
                        />
                        <label class="form-check-label" for="flexRadioDefault5">
                          Yes
                        </label>
                      </div>
                    </div>

                    <div class="col-4">
                      <div class="form-check">
                        <input
                          class="form-check-input dangerous_no"
                          value="no"
                          type="radio"
                          name="noDangerous"
                          id="flexRadioDefault6"
                          checked=""
                        />
                        <label class="form-check-label" for="flexRadioDefault6">
                          No
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p class="mandatory-fields mb-0">
            <span class="text-danger">*</span> All fields are mandatory
          </p>

          <div class="d-flex justify-content-center my-5 form-buttons">
            <button
              type="button"
              class="btn btn-support btn-outline-dark me-3 button_ship"
              @click="sendShipEmail()"
              value="submit"
            >
              Submit
            </button>
            <button
              type="reset"
              class="btn btn-support btn-outline-secondary reset"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
      <div id="customerService" class="hide">
        <form class="supportForm" action="">
          <div class="mb-3 row">
            <label class="col-sm-3 col-form-label"
              >Parcel tracking ID<span class="text-danger">*</span></label
            >
            <div class="col-sm-7">
              <input
                type="text"
                class="form-control"
                name="ltrackingId"
                required=""
                v-model="tracking_id_customer"
              />
            </div>
          </div>

          <h5 class="my-5 personal-head"><span>PERSONAL DETAILS</span></h5>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >First Name<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="firstName"
                    required=""
                    v-model="first_name_customer"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Last Name<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="lastName"
                    required=""
                    v-model="last_name_customer"
                  />
                </div>
              </div>
            </div>
          </div>

          <h5 class="my-5 personal-head">
            <span>SHIPPING ADDRESS ON PARCEL</span>
          </h5>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >House number<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="houseNumber"
                    required=""
                    v-model="house_customer"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Street name<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="streetName"
                    required=""
                    v-model="street_customer"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label">Apt number</label>
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="aptName"
                    v-model="apt_number_customer"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >City<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="cityName"
                    required=""
                    v-model="city_customer"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Province<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="province1"
                    required=""
                    v-model="province_customer"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Postal Code<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="postalCode1"
                    required=""
                    v-model="postal_code_customer"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Phone number<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control"
                    name="phoneNumber1"
                    required=""
                    placeholder="XXX XXX XXXX"
                    pattern="[0-9]{3} [0-9]{3} [0-9]{4}"
                    maxlength="12"
                    v-model="phone_customer"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6"></div>
          </div>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Email Address<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <input
                    type="text"
                    class="form-control customer_email_address"
                    name="emailCustomer1"
                    required=""
                    placeholder=""
                    v-model="email_customer"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6"></div>
          </div>

          <h5 class="my-5"><span>OTHER DETAILS</span></h5>

          <div class="mb-3 row">
            <div class="col-md-6">
              <div class="mb-4 row">
                <label class="col-sm-4 col-form-label"
                  >Comments<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <textarea
                    type="text"
                    rows="5"
                    class="form-control customer_comments"
                    name="fullDescription"
                    required=""
                  ></textarea>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3 row">
                <label class="col-sm-4 col-form-label"
                  >Reason Code<span class="text-danger">*</span></label
                >
                <div class="col-sm-8">
                  <select
                    class="form-select customer_reason"
                    name="reasonCode1"
                    required=""
                  >
                    <option value="" selected=""></option>

                    <option value="Damaged" class="Damaged">Damaged</option>

                    <option
                      value="Delivered but not received"
                      class="Delivered but not received"
                    >
                      Delivered but not received
                    </option>

                    <option
                      value="Past expected delivery time"
                      class="Past expected delivery time"
                    >
                      Past expected delivery time
                    </option>

                    <option value="General Inquiry" class="General Inquiry">
                      General Inquiry
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <p class="mandatory-fields mb-0">
            <span class="text-danger">*</span> Are Mandatory Fields
          </p>

          <div class="d-flex justify-content-center my-5 form-buttons">
            <button
              type="button"
              @click="sendServiceEmail()"
              class="btn btn-support btn-outline-dark me-3 button_service"
              value="submit"

            >
              Submit
            </button>

            <button
              type="reset"
              class="btn btn-support btn-outline-secondary reset"
            >
              Reset
            </button>
          </div>
        </form>
      </div>
      <div id="pickupDetails" class="hide">
        <div class="mb-3">
          <p class="pickup_location"></p>
        </div>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";
import axios from "axios";
window.dataLayer = window.dataLayer || [];
import { parcel_api } from '@/js_utils/urls.js'

export default {
  beforeMount() {
    scroll(0, 0);
  },
  methods: {
    supportTicketSent(success,Id) {
      if (success == true) {
        window.dataLayer.push({
         'event': 'formSuccess',
         'Id': Id
         });
        document.querySelector(".pickup_location").innerHTML =
          "Your support ticket has been placed, and we will work to get back to you as soon as possible.";
      } else {
        document.querySelector(".pickup_location").innerHTML =
          "We are sorry for the inconvenience, but there was an error submitting your support ticket. Our team has been notified and we are working on a fix.";
      }
      document.querySelector("#pickupDetails").classList.remove("hide");
      document.querySelector("#pickupDetails").scrollIntoView();
      document.querySelector(".button_service").disabled = false;
      document.querySelector(".button_ship").disabled = false;
      document.querySelector("#shipWithUs").classList.add("hide");
      document.querySelector("#customerService").classList.add("hide");
      document.querySelector(".siteViewport").classList.remove("greyOut");
      document.querySelector("#radio1").checked = false
      document.querySelector("#radio2").checked = false
      document.querySelector("#radio3").checked = false
      document.querySelector(".supportLoader").hidden = true;
    },
    shipWithUsForm() {
      document.querySelector("#shipWithUs").classList.remove("hide");
      document.querySelector("#customerService").classList.add("hide");
      document.querySelector("#pickupDetails").classList.add("hide");
    },
    customerServiceForm() {
      document.querySelector("#shipWithUs").classList.add("hide");
      document.querySelector("#customerService").classList.remove("hide");
      document.querySelector("#pickupDetails").classList.add("hide");
    },

    driveForUsRedirect() {
      this.$router.push("/careers");
    },

    /* eslint-disable */
    sendServiceEmail() {
      document.querySelector(".button_service").disabled = true;
      document.querySelector("#customerService").disabled = true;
      document.querySelector(".siteViewport").classList.add("greyOut");
      document.querySelector(".supportLoader").hidden = false;

      let subject = "Shipping Tracking Query";
      let customer_comments =
        document.querySelector(".customer_comments").value;
      let customer_reason = document.querySelector(".customer_reason").value;

      if (
        this.tracking_id_customer == "" ||
        this.first_name_customer == "" ||
        this.last_name_customer == "" ||
        this.phone_customer == "" ||
        this.email_customer == "" ||
        this.house_customer == "" ||
        this.street_customer == "" ||
        this.city_customer == "" ||
        this.province_customer == "" ||
        this.postal_code_customer == "" ||
        customer_comments == "" ||
        customer_reason == ""
      ) {
        alert("Please fill out all required fields before submitting.");
       document.querySelector(".button_service").disabled = false;
        return;
      }

      let email_pattern = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
      let email_match = email_pattern.test(this.email_customer)

      if(!email_match) {
        alert("Invalid email entered. Please ensure your email matches the following format: example@domain.com");
        document.querySelector(".button_service").disabled = false;
        document.querySelector(".customer_email_address").scrollIntoView()
        document.querySelector(".customer_email_address").focus()
        return;
      }

      let email_body =
        "Tracking Id " +
        this.tracking_id_customer +
        "<br>" +
        "Name " +
        this.first_name_customer +
        " " +
        this.last_name_customer +
        "<br>" +
        "House Number " +
        this.house_customer +
        "<br>" +
        "Street " +
        this.street_customer +
        "<br>" +
        "Apt Name " +
        this.apt_number_customer +
        "<br>" +
        "City Name " +
        this.city_customer +
        "<br>" +
        "Province " +
        this.province_customer +
        "<br>" +
        "Postal Code " +
        this.postal_code_customer +
        "<br>" +
        "Comment " +
        customer_comments +
        "<br>" +
        "Phone Number " +
        this.phone_customer +
        "<br>" +
        "Reason Code " +
        customer_reason +
        "<br>" +
        "Email " + 
        this.email_customer +
        "<br><br><br>";

      let email_json = {
        body: email_body,
        subject: subject,
        type: "service",
      };

      axios
        .post(parcel_api.concat('/email'),
          JSON.stringify(email_json)
        )
        .then((res) => {
          this.tracking_id_customer = "";
          let success;
          let Id = 1002;
          if (res["data"] == 1) success = true;
          else success = false;
          this.supportTicketSent(success,Id);

        })
        .catch((error) => {
          console.log(error);
          this.supportTicketSent(false,0)
        });
    },
    sendShipEmail() {
      document.querySelector(".button_ship").disabled = true;
      document.querySelector("#shipWithUs").disabled = true;
      document.querySelector(".siteViewport").classList.add("greyOut");
      document.querySelector(".supportLoader").hidden = false;

      if (
        this.first_name_ship == "" ||
        this.last_name_ship == "" ||
        this.email_address_ship == "" ||
        this.phone_ship == "" ||
        this.org_ship == "" ||
        this.shipping_vol_ship == "" ||
        this.city_ship == "" ||
        this.province_ship == ""
      ) {
        alert("Please fill out all required fields before submitting.");
        document.querySelector(".button_ship").disabled = false;      
        return;
      }


      let subject = "Ship With Us Inquiry";
      let domestic, under50, dangerous;

      if (document.querySelector(".domestic_yes").checked == true) {
        domestic = "Yes";
      } else {
        domestic = "No";
      }
      if (document.querySelector(".under_yes").checked == true) {
        under50 = "Yes";
      } else {
        under50 = "No";
      }
      if (document.querySelector(".dangerous_yes").checked == true) {
        dangerous = "Yes";
      } else {
        dangerous = "No";
      }
      let email_body =
        "Name " +
        this.first_name_ship +
        " " +
        this.last_name_ship +
        "<br>" +
        "Email " +
        this.email_address_ship +
        "<br>" +
        "Phone " +
        this.phone_ship +
        "<br>" +
        "Organization " +
        this.org_ship +
        "<br>" +
        "City Name " +
        this.city_ship +
        "<br>" +
        "Province " +
        this.province_ship +
        "<br>" +
        "Estimated Shipping Volume " +
        this.shipping_vol_ship +
        "<br>" +
        "Domestic: " +
        domestic +
        "<br>" +
        "Under 50lbs: " +
        under50 +
        "<br>" +
        "Dangerous Goods: " +
        dangerous +
        "<br><br><br>This email was generated by user input from the support page at https://postmediaparcelservices.bnidistribution.com/support";

      let email_json = {
        body: email_body,
        subject: subject,
        type: "shipping",
      };

      axios
       .post(parcel_api.concat('/email'),
          JSON.stringify(email_json)
        )
        .then((res) => {
          let success;
          let Id = 1001;

          if (res["data"] == 1) success = true;
          else success = false;
          this.supportTicketSent(success,Id);
        })
        .catch((error) => {
          console.log(error);
          this.supportTicketSent(false,0)
        });
    }
  },
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
  data: function () {
    return {
      ship_with_us: false,
      customer_service: false,

      first_name_customer: "",
      last_name_customer: "",
      tracking_id_customer: "",
      name_customer: "",
      province_customer: "",
      city_customer: "",
      phone_customer: "",
      email_customer: "",
      house_customer: "",
      street_customer: "",
      postal_code_customer: "",
      apt_number_customer: "",

      first_name_ship: "",
      last_name_ship: "",
      email_address_ship: "",
      phone_ship: "",
      org_ship: "",
      city_ship: "",
      province_ship: "",
      shipping_vol_ship: ""
    };
  },
};
</script>